import { render } from "./SiteContactForm.vue?vue&type=template&id=1a298c8b&scoped=true"
import script from "./SiteContactForm.vue?vue&type=script&lang=js"
export * from "./SiteContactForm.vue?vue&type=script&lang=js"

import "./SiteContactForm.vue?vue&type=style&index=0&id=1a298c8b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a298c8b"]])

export default __exports__